import {
    isReservationExistingPerson,
    isReservationNewPerson,
    ReservationPerson,
    ReservationState,
} from '@digitalopsdev/serviceops-reservations-components/dist/EditReservation/model';

export interface CustomerContactInfo {
    name: string;
    phone: string;
    email: string;
}

export async function getCustomerContactInfo(
    person: ReservationPerson,
    reservationState: ReservationState
): Promise<CustomerContactInfo> {
    const emptyResult: CustomerContactInfo = { name: '', phone: '', email: '' };

    if (!person) {
        return emptyResult;
    }

    if (isReservationExistingPerson(person)) {
        try {
            const personDto = await reservationState.PersonCache.fetchPersonDetails(
                person.PersonId,
                reservationState.NewPeople
            );

            if (personDto) {
                const firstName = personDto.FirstName ?? '';
                const lastName = personDto.LastName ?? '';
                const displayName = `${firstName} ${lastName}`.trim();

                return {
                    name: displayName,
                    phone: personDto.PhoneNumber ?? '',
                    email: personDto.Email ?? '',
                };
            }
        } catch (error) {
            console.warn(`Could not fetch contact info for person ${person.PersonId}:`, error);
        }
        return emptyResult;
    } else if (isReservationNewPerson(person)) {
        const firstName = person.FirstName ?? '';
        const lastName = person.LastName ?? '';
        const displayName = `${firstName} ${lastName}`.trim();

        return {
            name: displayName,
            phone: person.Phone ?? '',
            email: person.Email ?? '',
        };
    }

    return emptyResult;
}
